import {
    getAxios,
} from './axios'

import {addAuthTokenData} from './member';
import {addCacheBuster} from '../utils/url';

export function getMemberFollowing(params = {}) {
    let axios = getAxios();

    return axios.request({
        url: addCacheBuster('/member/followees/'),
        method: 'get',
        params: {...addAuthTokenData(params)}
    });
}


// WEBPACK FOOTER //
// ./src/backend-helpers/memberFollowing.js